/* ZCT_V22_KOPF (E1): Verhalten der Seitenhülle wie in v21, gleiche Klassen, Schwellen und Takte.
   - zct-ankuendigung (JS-003): nächster Text alle 3,8 s, harter Tausch ohne Überblenden.
   - zct-kopf (JS-004 bis JS-009): Kopfleiste nav-clear / nav-liquid / nav-pdp (scrollY > 20, ZEN-Raum unter der
     Leiste, Produktbild hinter der Leiste bis 768 px), Logo-Wechsel, Prüfung bei scroll, resize und alle 350 ms;
     --nav-h beim Start, bei resize und alle 500 ms; Overlay-Menü mit Unterpanels und Kollektions-Ausklapper;
     Suche mit Produktliste aus #zct-produkte; Escape schließt Suche und Menü; Body-Sperre solange Menü oder Suche offen;
     bis 768 px springt die Seite beim Öffnen des Menüs nach oben (wie v21). Sprachwechsel wie ZP_SWITCH.
   Bewegung macht ausschließlich das vorhandene CSS (Klassen wie in v21). */
(function () {
  'use strict';

  var EN = (document.documentElement.lang || 'de').slice(0, 2) === 'en';
  var ROOT = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/$/, '');
  function texte() { var el = document.getElementById('zct-texte'); try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; } }
  var TEXTE = texte();
  function entschluesseln(s) { if (typeof s !== 'string' || s.indexOf('&') < 0) return s; var t = document.createElement('textarea'); t.innerHTML = s; return t.value; }
  function tx(k) { return TEXTE[k] != null ? entschluesseln(TEXTE[k]) : k; }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  // Sprachwechsel wie ZP_SWITCH in v21 (gleicher Pfad in der anderen Sprache, Abfrage bleibt)
  function spracheWechseln() {
    var nach = EN ? '' : '/en';
    var pfad = location.pathname.replace(/^\/(de|en)(?=\/|$)/, '') || '/';
    location.href = nach + pfad + location.search;
  }

  class ZctAnkuendigung extends HTMLElement {
    connectedCallback() {
      var daten = this.querySelector('script[type="application/json"]');
      var slide = this.querySelector('.ann .slide');
      var folien = [];
      try { folien = JSON.parse(daten.textContent); } catch (e) {}
      if (!slide || folien.length < 2) return;
      var i = 0;
      var takt = Number(this.getAttribute('data-wechsel')) || 3800;
      this.uhr = setInterval(function () { i = (i + 1) % folien.length; slide.innerHTML = folien[i]; }, takt);
    }
    disconnectedCallback() { clearInterval(this.uhr); }
  }

  class ZctKopf extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.ab = new AbortController();
      var s = { signal: this.ab.signal };
      var nav = this.querySelector('nav.nav');
      var menue = this.querySelector('.overlay-menu');
      if (!nav || !menue) return;
      var logo = nav.querySelector('.brand .logo-img');
      var logoWeiss = this.getAttribute('data-logo-weiss');
      var logoSchwarz = this.getAttribute('data-logo-schwarz');
      var knopf = nav.querySelector('.nav-menu-btn');
      var knopfText = knopf && knopf.querySelector('.nav-menu-label');
      var seite = document.body.getAttribute('data-page') || 'home';
      var zustand = { menue: false, suche: false, scrolled: false, zenroom: false, pdpHinter: true, kat: false, kol: false, navigiert: false };

      // ----- Kopfleiste (JS-004) -----
      function klassen() {
        var clear = (['home', 'about', 'zen', 'tukkon'].indexOf(seite) >= 0) && !zustand.scrolled || zustand.zenroom;
        var k = 'nav' + (clear ? ' nav-clear' : '') + (zustand.scrolled && !clear ? ' nav-liquid' : '') + (seite === 'pdp' && zustand.pdpHinter ? ' nav-pdp' : '');
        if (nav.className !== k) nav.className = k;
        var src = clear ? logoWeiss : logoSchwarz;
        if (logo && logo.getAttribute('src') !== src) logo.setAttribute('src', src);
        menueKlassen();
      }
      function pruefen() {
        zustand.scrolled = window.scrollY > 20;
        if (seite === 'home') {
          var el = document.querySelector('.zenroom');
          if (el) { var probe = (nav.offsetHeight || 72) + 4; var r = el.getBoundingClientRect(); zustand.zenroom = r.top <= probe && r.bottom > probe; }
          else zustand.zenroom = false;
        } else zustand.zenroom = false;
        if (seite === 'pdp' && window.innerWidth <= 768) {
          var mi = document.querySelector('.pdp .main-img');
          if (mi) { var h = nav.offsetHeight || 65; zustand.pdpHinter = mi.getBoundingClientRect().bottom > h; }
          else zustand.pdpHinter = true;
        } else zustand.pdpHinter = true;
        klassen();
      }
      var scroller = document.scrollingElement || document.documentElement;
      window.addEventListener('scroll', pruefen, { passive: true, signal: this.ab.signal });
      if (scroller && scroller.addEventListener) scroller.addEventListener('scroll', pruefen, { passive: true, signal: this.ab.signal });
      window.addEventListener('resize', pruefen, s);
      this.uhrPruefen = setInterval(pruefen, 350);

      // ----- --nav-h (JS-005) -----
      function messen() { document.documentElement.style.setProperty('--nav-h', nav.offsetHeight + 'px'); }
      messen();
      window.addEventListener('resize', messen, s);
      this.uhrMessen = setInterval(messen, 500);

      // ----- Overlay-Menü (JS-006 bis JS-008) -----
      var katPanel = this.querySelector('#om-categories-panel');
      var kolPanel = this.querySelector('#om-collections-panel');
      var katKnopf = this.querySelector('.om-link-cats');
      var kolKnopf = this.querySelector('.om-link-cols');
      var flyoutVorlage = this.querySelector('template[data-zct-flyout]');
      var flyout = null;
      function menueKlassen() {
        var k = 'overlay-menu ' + (zustand.menue ? 'open' : '') + (zustand.scrolled && window.innerWidth > 768 ? ' scrolled' : '');
        if (menue.className !== k) menue.className = k;
      }
      function panels() {
        if (katPanel) katPanel.className = 'om-sub-panel' + (zustand.kat ? ' open' : '');
        if (kolPanel) kolPanel.className = 'om-sub-panel om-sub-panel-cols' + (zustand.kol ? ' open' : '');
        if (katKnopf) katKnopf.setAttribute('aria-expanded', String(zustand.kat));
        if (kolKnopf) kolKnopf.setAttribute('aria-expanded', String(zustand.kol));
        if (zustand.kol && !flyout && flyoutVorlage) {
          flyout = flyoutVorlage.content.firstElementChild.cloneNode(true);
          flyoutVorlage.after(flyout);
          flyout.addEventListener('click', function () { zustand.kol = false; panels(); });
          var innen = flyout.querySelector('.col-flyout-inner');
          if (innen) innen.addEventListener('click', function (e) { e.stopPropagation(); });
        } else if (!zustand.kol && flyout) { flyout.remove(); flyout = null; }
      }
      function sperre() { document.body.style.overflow = zustand.menue || zustand.suche ? 'hidden' : ''; }
      function bilderNeu(an) {
        menue.querySelectorAll('.om-product-img img[data-zct-src]').forEach(function (img) {
          if (an) { img.setAttribute('src', img.getAttribute('data-zct-src')); img.setAttribute('srcset', img.getAttribute('data-zct-srcset')); }
          else { img.removeAttribute('src'); img.removeAttribute('srcset'); }
        });
      }
      function menueSetzen(an) {
        zustand.menue = an;
        if (!an) { zustand.kat = false; zustand.kol = false; panels(); }
        menueKlassen();
        if (an) {
          menue.style.transform = 'translateX(0)';
          menue.setAttribute('role', 'dialog'); menue.setAttribute('aria-modal', 'true');
          menue.removeAttribute('aria-hidden'); menue.removeAttribute('inert');
          // E7 (Fokus): Fokus auf „Schließen“ im Menü, beim Schließen zurück auf den Menüknopf (für Maus und Touch unsichtbar).
          // Das Menü blendet über visibility ein; im ersten Moment nimmt der Browser keinen Fokus an, daher kurz danach (und einmal nachfassen).
          [60, 400].forEach(function (ms) {
            setTimeout(function () { if (zustand.menue && zuKnopf && !menue.contains(document.activeElement)) zuKnopf.focus({ preventScroll: true }); }, ms);
          });
        } else {
          if (knopf && menue.contains(document.activeElement)) knopf.focus({ preventScroll: true });
          menue.style.removeProperty('transform'); if (!menue.getAttribute('style')) menue.removeAttribute('style');
          menue.removeAttribute('role'); menue.removeAttribute('aria-modal');
          menue.setAttribute('aria-hidden', 'true'); menue.setAttribute('inert', '');
        }
        if (knopf) { knopf.className = 'nav-menu-btn link' + (an ? ' active' : ''); knopf.setAttribute('aria-expanded', an ? 'true' : 'false'); }
        if (knopfText) knopfText.textContent = an ? tx('schliessen') : tx('menue');
        bilderNeu(an);
        sperre();
        if (an && window.innerWidth <= 768) window.scrollTo(0, 0);
      }
      if (knopf) knopf.addEventListener('click', function () { menueSetzen(!zustand.menue); }, s);
      var zuKnopf = this.querySelector('[data-zct-menue-zu]');
      if (zuKnopf) zuKnopf.addEventListener('click', function () { menueSetzen(false); }, s);
      if (katKnopf) katKnopf.addEventListener('click', function () { if (!zustand.navigiert) { zustand.kat = true; panels(); } }, s);
      if (kolKnopf) kolKnopf.addEventListener('click', function () { if (!zustand.navigiert) { zustand.kol = true; panels(); } }, s);
      menue.addEventListener('click', function (e) {
        var t = e.target;
        if (t.closest('.om-sub-back')) {
          var p = t.closest('.om-sub-panel');
          if (p === katPanel) zustand.kat = false; else zustand.kol = false;
          panels(); return;
        }
        if (t.closest('.om-sub-close')) { menueSetzen(false); return; }
        if (t.closest('.om-search')) { menueSetzen(false); sucheSetzen(true); return; }
        if (t.closest('.nav-lang') || t.closest('.om-lang-btn')) { spracheWechseln(); return; }
        // Menülinks: wie nav() in v21 Menü schließen, 400 ms keine Unterpanels; die Seite lädt dann neu
        var a = t.closest('a[href]');
        if (a && !a.target && !(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) && e.button === 0) {
          zustand.navigiert = true; zustand.kat = false; zustand.kol = false; panels(); menueSetzen(false);
          setTimeout(function () { zustand.navigiert = false; }, 400);
        }
      }, s);
      nav.addEventListener('click', function (e) { if (e.target.closest('.nav-lang')) spracheWechseln(); }, s);

      // ----- Suche (JS-009) -----
      var sucheVorlage = this.querySelector('template[data-zct-suche]');
      var ebene = null;
      var produkte = (window.zctLaden && window.zctLaden.produkte) || [];
      var fmt = (window.zctLaden && window.zctLaden.fmt) || function (n) { return String(n); };
      function seitenTreffer(term) {
        var liste = [
          { id: 'zen', name: 'ZEN Kollektion', keys: 'zen kollektion collection', href: '/collections/zen' },
          { id: 'tukkon-col', name: 'TUKKON Kollektion', keys: 'tukkon kollektion collection', href: '/collections/tukkon' },
          { id: 'bestseller-col', name: 'Bestseller', keys: 'bestseller best seller zen taisho kinko kollektion collection', href: '/collections/bestseller' },
          { id: 'gift', name: tx('geschenkgutschein'), keys: 'gutschein geschenk gift voucher geschenkgutschein', href: '/products/gift-card' },
          { id: 'blog', name: 'Blog', keys: 'blog werkstatt workshop stories', href: '/blogs/news' },
          { id: 'about', name: tx('ueber_uns_seite'), keys: 'über uns about werkstatt workshop team', href: '/pages/about' },
          { id: 'care', name: tx('pflege_seite'), keys: 'pflege care gewährleistung statutory warranty patina oberfläche surface', href: '/pages/pflege' },
          { id: 'b2b', name: tx('b2b'), keys: 'b2b wholesale business programm', href: '/pages/b2b' }
        ];
        return liste.filter(function (p) { return p.keys.indexOf(term) >= 0 || p.name.toLowerCase().indexOf(term) >= 0; });
      }
      function pfeil() { return '<svg class="ico " viewBox="0 0 16 16"><path d="M3 8h10m-4-4l4 4-4 4"></path></svg>'; }
      function trefferZeichnen(q) {
        if (!ebene) return;
        var koerper = ebene.querySelector('.search-body');
        var term = q.trim().toLowerCase();
        if (!term) { koerper.innerHTML = ebene._leer; return; }
        var ergebnisse = produkte.filter(function (p) {
          var heu = [p.name, p.id, p.kat, (p.toene || []).join(' '), p.monoDe, p.descDe, p.taglineDe].filter(Boolean).join(' ').toLowerCase();
          return heu.indexOf(term) >= 0;
        }).slice(0, 8);
        var seiten = seitenTreffer(term);
        var h = '';
        if (!ergebnisse.length && !seiten.length) {
          h += '<div class="search-empty"><div style="padding: 40px 0px; text-align: center; color: var(--ink-2);">' + esc(tx('keine_treffer_vor') + q + tx('keine_treffer_nach')) +
            '<br><span style="font-size: 13px; color: var(--ink-3);">' + esc(tx('versuche')) + '</span></div></div>';
        }
        if (seiten.length) {
          h += '<div class="search-results"><div class="search-eyebrow">' + esc(tx('seiten')) + '</div>';
          seiten.forEach(function (p) {
            h += '<a href="' + esc(ROOT + p.href) + '" class="search-row"><div class="search-thumb" style="background: var(--paper-3); display: flex; align-items: center; justify-content: center;">' + pfeil() +
              '</div><div class="search-meta"><div class="search-name">' + esc(p.name) + '</div></div>' + pfeil() + '</a>';
          });
          h += '</div>';
        }
        if (ergebnisse.length) {
          h += '<div class="search-results"><div class="search-eyebrow">' + ergebnisse.length + ' ' + esc(tx('treffer')) + '</div>';
          ergebnisse.forEach(function (p) {
            var bild = p.img ? '<div class="ph has-img "><img src="' + esc(window.zctLaden.bildUrl(p.img, 1600)) + '" srcset="' + esc(window.zctLaden.bildSet(p.img)) +
              '" sizes="(max-width: 680px) 92vw, (max-width: 1100px) 48vw, 560px" alt="' + esc(p.name) + '" loading="lazy" decoding="async" referrerpolicy="no-referrer"></div>' : '';
            var unter = (p.monoDe || p.katText || '') + ' ' + (p.preis ? ' · ' + tx('ab') + ' ' + fmt(p.preis / 100) : ' · ' + tx('auf_anfrage_suche'));
            h += '<a href="' + esc(ROOT + '/products/' + encodeURIComponent(p.handle || p.id)) + '" class="search-row"><div class="search-thumb">' + bild + '</div><div class="search-meta"><div class="search-name">' + esc(p.name) +
              '</div><div class="search-sub">' + esc(unter) + '</div></div>' + pfeil() + '</a>';
          });
          h += '</div>';
        }
        koerper.innerHTML = h;
      }
      function sucheSetzen(an) {
        if (an === zustand.suche) return;
        zustand.suche = an;
        if (an && sucheVorlage) {
          ebene = sucheVorlage.content.firstElementChild.cloneNode(true);
          ebene._leer = ebene.querySelector('.search-body').innerHTML;
          menue.after(ebene);
          var feld = ebene.querySelector('.search-top input');
          ebene.addEventListener('click', function () { sucheSetzen(false); menueSetzen(false); });
          ebene.querySelector('.search-panel').addEventListener('click', function (e) {
            e.stopPropagation();
            var t = e.target;
            if (t.closest('.search-top button')) { sucheSetzen(false); menueSetzen(false); return; }
            var tag = t.closest('.search-tag');
            if (tag) { feld.value = tag.textContent; trefferZeichnen(feld.value); return; }
            var a = t.closest('a[href]');
            if (a && e.button === 0 && !(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)) { sucheSetzen(false); menueSetzen(false); }
          });
          feld.addEventListener('input', function () { trefferZeichnen(feld.value); });
          feld.focus();
          setTimeout(function () { if (feld.isConnected) feld.focus(); }, 50);
        } else if (!an && ebene) {
          ebene.remove(); ebene = null;
        }
        sperre();
      }
      this.addEventListener('click', function (e) {
        var t = e.target;
        if (t.closest && t.closest('[data-zct-suche-auf]')) sucheSetzen(true);
      }, s);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { sucheSetzen(false); menueSetzen(false); } }, s);

      pruefen();
    }
    disconnectedCallback() {
      if (this.ab) this.ab.abort();
      clearInterval(this.uhrPruefen);
      clearInterval(this.uhrMessen);
    }
  }

  if (!customElements.get('zct-ankuendigung')) customElements.define('zct-ankuendigung', ZctAnkuendigung);
  if (!customElements.get('zct-kopf')) customElements.define('zct-kopf', ZctKopf);
})();
